export default __webpack_public_path__ + "static/media/worms_alone.75b1d35b.png";